import React, { ReactNode } from 'react'

export default function Card({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={(className ? className : '') + ' shadow sm:rounded-md overflow-auto bg-white'}>{children}</div>
}
